'use client';

import { UTCDate } from '@date-fns/utc';
import { endOfMonth } from 'date-fns';
import { useGetGameFromRouteParams } from '@/hooks/useGetGameFromParams.hook';
import type { PoweredBy } from '@/types/sponsor';
import { PickemRewardCard } from './PickemRewardCard';
import { PickemsRewardsHeader } from './PickemsRewardsHeader';
import type { Reward } from './rewards';

export const PickemsRewardsSection = ({
  rewards,
  poweredBy,
}: {
  rewards: Reward[];
  poweredBy: PoweredBy;
}) => {
  const { game } = useGetGameFromRouteParams();
  const endOfMonthAtUTC = endOfMonth(new UTCDate());

  return (
    <div className="rounded-xl bg-dark-gray p-8">
      <PickemsRewardsHeader
        countdownDatetime={endOfMonthAtUTC}
        countdownLabel="Monthly leaderboard reset in:"
        description="Winners of the contest will have something nice to look forward to! Rewards are courtesy of our partners."
        leaderboardUrl={`/${game}/pickems/leaderboard`}
        poweredBy={poweredBy}
        title="Monthly Pickems"
      />
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
        {rewards.map((reward, index) => (
          <PickemRewardCard index={index} key={reward.label} reward={reward} />
        ))}
      </div>
    </div>
  );
};
